import { createShortlistStore } from './storage'
import { bindShortlistSync } from './sync'
import {
  bindShortlistToggle,
  candidateFromElement,
  shortlistFailureMessage,
} from './toggle'

const initializedRoots = new WeakSet()
const initializedListLinks = new WeakSet()
const feedbackTimers = new WeakMap()

function candidateFromRoot(root) {
  const card = root.closest('[data-reform-case-shortlist-card]')
  return candidateFromElement(root, '[data-reform-case-shortlist-card-candidate]', card)
}

function setStatus(root, message) {
  const status = root.querySelector('[data-reform-case-shortlist-card-status]')
  if (status instanceof HTMLElement) status.textContent = message
}

function setFeedback(root, message, showListLink) {
  const feedback = root.querySelector('[data-reform-case-shortlist-card-feedback]')
  const feedbackMessage = root.querySelector('[data-reform-case-shortlist-card-feedback-message]')
  const feedbackLink = root.querySelector('[data-reform-case-shortlist-card-feedback-link]')
  if (!(feedback instanceof HTMLElement) || !(feedbackMessage instanceof HTMLElement)) return

  const existingTimer = feedbackTimers.get(root)
  if (existingTimer !== undefined) window.clearTimeout(existingTimer)

  feedbackMessage.textContent = message
  feedback.hidden = message === ''
  if (feedbackLink instanceof HTMLAnchorElement) feedbackLink.hidden = !showListLink

  if (message !== '') {
    feedbackTimers.set(root, window.setTimeout(() => {
      if (feedback.contains(document.activeElement)) {
        feedbackTimers.delete(root)
        return
      }
      feedback.hidden = true
      feedbackTimers.delete(root)
    }, 6000))
  }
}

function renderListLink(listLink, count) {
  if (!(listLink instanceof HTMLAnchorElement)) return

  listLink.hidden = count === 0
  listLink.querySelectorAll('[data-reform-case-shortlist-list-count]').forEach((element) => {
    element.textContent = String(count)
  })
}

function bindListLink(listLink, store) {
  bindShortlistSync(listLink, () => {
    const result = store.read()
    renderListLink(listLink, result.ok ? result.count : 0)
  })
}

function render(root, state, message = '') {
  const button = root.querySelector('[data-reform-case-shortlist-card-toggle]')
  const label = root.querySelector('[data-reform-case-shortlist-card-label]')
  if (!(button instanceof HTMLButtonElement) || !(label instanceof HTMLElement)) return
  if (!state.ok) {
    label.textContent = 'いいね不可'
    setStatus(root, shortlistFailureMessage(state.reason))
    setFeedback(root, '', false)
    return
  }

  label.textContent = state.label
  setStatus(root, message)
  setFeedback(root, message, state.isSaved)
}

export function initReformCaseShortlistCards({ store = createShortlistStore() } = {}) {
  document.querySelectorAll('[data-reform-case-shortlist-list-link]').forEach((listLink) => {
    if (!(listLink instanceof HTMLAnchorElement) || initializedListLinks.has(listLink)) return
    initializedListLinks.add(listLink)
    bindListLink(listLink, store)
  })

  document.querySelectorAll('[data-reform-case-shortlist-card-control]').forEach((root) => {
    if (!(root instanceof HTMLElement) || initializedRoots.has(root)) return
    initializedRoots.add(root)

    const candidate = candidateFromRoot(root)
    if (candidate !== null) root.dataset.reformCaseShortlistTitle = candidate.snapshot.title
    bindShortlistToggle({
      root,
      store,
      candidate,
      buttonSelector: '[data-reform-case-shortlist-card-toggle]',
      render,
      successMessage: () => 'いいねしました。いいねした事例で見比べられます。',
    })
  })
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initReformCaseShortlistCards())
} else {
  initReformCaseShortlistCards()
}
